var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "el-uploader" },
    [
      _c("input", {
        ref: "upload",
        staticClass: "upload-input",
        attrs: { type: "file", accept: _vm.accept },
        on: { change: _vm.handleChange },
      }),
      _c(
        "el-button",
        {
          attrs: { icon: "el-icon-plus" },
          on: {
            click: function ($event) {
              return _vm.$refs.upload.click()
            },
          },
        },
        [_vm._v(" Choose File ")]
      ),
      _c(
        "div",
        { staticClass: "upload-progress" },
        [
          _vm.showProgress
            ? _c("el-progress", {
                attrs: {
                  percentage: _vm.percentage,
                  status: _vm.status,
                  "show-text": false,
                  "stroke-width": 3,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }